"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _dsWeb = require("@olxbr/ds-web");
var _client = require("@apollo/client");
var _RadioButton = _interopRequireDefault(require("../../RadioButton"));
var _ResultBox = _interopRequireDefault(require("../ResultBox"));
var _actions = require("../../../../actions");
var _style = require("./style");
var _resource = _interopRequireDefault(require("./resource"));
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var DenounceBox = function DenounceBox(_ref) {
  var closeModal = _ref.closeModal,
    reportType = _ref.reportType,
    roomname = _ref.roomname,
    denounceReceiverUserAction = _ref.denounceReceiverUserAction;
  var MUTATION_USER_DENOUNCE = (0, _client.gql)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation UserDenounce($selectedValue: String!, $roomname: String!) {\n      userDenounce(reason: $selectedValue, roomname: $roomname) {\n          chats{\n            roomname\n          }\n      }\n    }\n  "])));
  var _useMutation = (0, _client.useMutation)(MUTATION_USER_DENOUNCE),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    userDenounceMutation = _useMutation2[0];
  var _useState = (0, _react.useState)(_resource["default"]),
    _useState2 = _slicedToArray(_useState, 2),
    reasons = _useState2[0],
    setReasons = _useState2[1];
  var getValueOfSelectedItem = function getValueOfSelectedItem() {
    var selectedItem = reasons.find(function (reason) {
      return reason.selected;
    });
    return selectedItem && selectedItem.value;
  };
  var handleClose = function handleClose() {
    closeModal();
  };
  var handleSelectOption = function handleSelectOption(value) {
    setReasons(function (prevReasons) {
      return prevReasons.map(function (prevReason) {
        return _objectSpread(_objectSpread({}, prevReason), {}, {
          selected: prevReason.value === value
        });
      });
    });
  };
  var handleSend = function handleSend() {
    var selectedValue = getValueOfSelectedItem();
    return userDenounceMutation({
      variables: {
        selectedValue: selectedValue,
        roomname: roomname
      }
    }).then(function (_ref2) {
      var _data$userDenounce;
      var data = _ref2.data;
      if ((data === null || data === void 0 || (_data$userDenounce = data.userDenounce) === null || _data$userDenounce === void 0 || (_data$userDenounce = _data$userDenounce.chats) === null || _data$userDenounce === void 0 ? void 0 : _data$userDenounce.length) > 0) {
        denounceReceiverUserAction(selectedValue, errorModalRender, reportType);
      } else {
        denounceReceiverUserAction(selectedValue, errorModalRender, reportType);
        throw new Error('Error: No data returned from mutation.');
      }
    })["catch"](function (error) {
      denounceReceiverUserAction(selectedValue, errorModalRender, reportType);
      console.error('Error denounce user: ', error);
    });
  };
  var errorModalRender = function errorModalRender() {
    var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'UNKNOWN';
    var title = reason === 'NO_INTERNET' ? 'Você está sem Internet' : 'Não foi possível denunciar o usuário';
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResultBox["default"], {
      title: title,
      onPress: handleClose,
      children: "Espere um momento e tente novamente mais tarde."
    });
  };
  var disabledOk = !getValueOfSelectedItem();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
    "data-testid": "denounce-box-wrapper",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.TitleMedium, {
      children: "Por que voc\xEA est\xE1 denunciando este usu\xE1rio?"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodySmall, {
      color: "--color-neutral-110",
      children: "Sua den\xFAncia n\xE3o ser\xE1 compartilhada com o usu\xE1rio"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.RadioWrapper, {
      "data-testid": "denounce-box-options",
      children: reasons.map(function (_ref3) {
        var text = _ref3.text,
          value = _ref3.value,
          selected = _ref3.selected;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RadioButton["default"], {
          selected: selected,
          onClick: handleSelectOption,
          value: value,
          children: text
        }, value);
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.ButtonWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        onClick: handleClose,
        variant: "link-button",
        children: "Cancelar"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        onClick: handleSend,
        disabled: disabledOk,
        children: "Enviar"
      })]
    })]
  });
};
DenounceBox.propTypes = {
  closeModal: _propTypes.func.isRequired,
  reportType: _propTypes.string,
  roomname: _propTypes.string
};
DenounceBox.defaultProps = {
  reportType: 'chat'
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    denounceReceiverUserAction: _actions.denounceReceiverUser,
    closeModal: _actions.closeModal
  }, dispatch);
};
var _default = exports["default"] = (0, _actions.connect)(null, mapDispatchToProps)(DenounceBox);